import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_PAID_USER, IS_SOCIAL_USER } from 'reactApp/appHelpers/configHelpers';
import { promotionEndDate } from 'reactApp/appHelpers/featuresHelpers';

export const blackFriday2024: boolean =
    !IS_PAID_USER && !IS_BIZ_USER && !IS_SOCIAL_USER && promotionEndDate && getFeature('black-friday-2024');
